<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showCreateMartSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="header-title"
                 *ngIf="menuHomeEnumActive === menuHomeEnum.FoodOnboarding">
                Create new Food Partner
            </div>
            <div class="header-title"
                 *ngIf="menuHomeEnumActive === menuHomeEnum.MartOnboarding">
                Create new Mart Partner
            </div>
            <div class="header-sub-title">Provide the details from Hubspot</div>
        </div>
    </ng-template>
    <div class="bx-pager bx-default-pager">
        <div class="bx-pager-item active" (click)="nextTab(createPartnerTab.CompanyDetails)">
            <a class="bx-pager-link " data-slide-index="0">Company Details</a>
            <div class="arrow">
            </div>
        </div>
        <div class="bx-pager-item" (click)="personalForm.valid && nextTab(createPartnerTab.PersonalDetails)"
             [class.active]="activeCreatePartnerTab !== createPartnerTab.CompanyDetails"
             [class.disabled]="personalForm.invalid">
            <a class="bx-pager-link" data-slide-index="1">Personal Details</a>
            <div class="arrow">
            </div>
        </div>
        <div class="bx-pager-item" (click)="serviceForm.valid && nextTab(createPartnerTab.Service)"
             [class.disabled]="serviceForm.invalid"
             [class.active]="(activeCreatePartnerTab === createPartnerTab.Service || activeCreatePartnerTab === createPartnerTab.Proposal || activeCreatePartnerTab === createPartnerTab.Preview)">
            <a class="bx-pager-link" data-slide-index="2">Service</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" (click)="proposalForm.valid && nextTab(createPartnerTab.Proposal)"
           [class.disabled]="proposalForm.invalid"
           [class.active]="activeCreatePartnerTab === createPartnerTab.Proposal">
            <a class="bx-pager-link" data-slide-index="3">Proposal</a>
        </div>
    </div>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <form [formGroup]="partnerDetailsForm" class="promo-detail-body" *ngIf="activeCreatePartnerTab === createPartnerTab.CompanyDetails">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 240px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="merchant-body-title">Complete all the information you know, otherwise leave blank</div>
                 
                    <div class="merchant-form">
                        <div class="merchant-label">Registered company name (same as SEC document) *</div>
                        <input type="text" formControlName="BusinessName" placeholder="Type here…" pInputText class="italic" (blur)="validateField('BusinessName')"/>
                        <div class="error-message" *ngIf="partnerDetailsForm.get('BusinessName')?.touched && !partnerDetailsForm.get('BusinessName')?.value">
                            This field is required.
                        </div>
                    </div>
                    <div class="merchant-form">
                        <div class="merchant-label">Registered company address (same as SEC document) *</div>
                        <p-autoComplete formControlName="BusinessAddress"
                                        [suggestions]="addresses"
                                        (completeMethod)="search($event)"
                                        placeholder="Search in Google Maps"
                                        [inputStyle]="{'width': '608px'}">
                        </p-autoComplete>
                        <div class="error-message" *ngIf="partnerDetailsForm.get('BusinessAddress')?.touched && !partnerDetailsForm.get('BusinessAddress')?.value">
                            This field is required.
                        </div>
                    </div>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <input type="text" formControlName="BusinessCity" placeholder="City" pInputText (blur)="validateField('BusinessCity')"/>
                            <div class="error-message" *ngIf="partnerDetailsForm.get('BusinessCity')?.touched && !partnerDetailsForm.get('BusinessCity')?.value">
                                This field is required.
                            </div>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <input type="text" formControlName="BusinessPostalCode" placeholder="Zip Code" pInputText (blur)="validateField('BusinessPostalCode')"/>
                            <div class="error-message" *ngIf="partnerDetailsForm.get('BusinessPostalCode')?.touched && !partnerDetailsForm.get('BusinessPostalCode')?.value">
                                This field is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="merchant-form">
                    <div class="merchant-label">Trading name (what will be published in app) *</div>
                    <input type="text" formControlName="TradingName" placeholder="Type here…" pInputText class="italic" />
                    <div class="error-message" *ngIf="partnerDetailsForm.get('TradingName')?.touched && !partnerDetailsForm.get('TradingName')?.value">
                        This field is required.
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Company Phone *</div>
                            <input type="text" formControlName="BusinessPhone" placeholder="+63" pInputText class="italic" />
                            <div class="error-message" *ngIf="partnerDetailsForm.get('BusinessPhone')?.touched && !partnerDetailsForm.get('BusinessPhone')?.value">
                                This field is required.
                            </div>
                            <div class="error-message" *ngIf="partnerDetailsForm.get('BusinessPhone')?.touched && partnerDetailsForm.get('BusinessPhone')?.hasError('pattern')">
                                Please enter a valid PH mobile number (e.g +639123456789).
                              </div>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Company Email *</div>
                            <input type="email" formControlName="BusinessEmail"  placeholder="Email" pInputText class="italic" />
                            <div class="error-message" *ngIf="partnerDetailsForm.get('BusinessEmail')?.touched && !partnerDetailsForm.get('BusinessEmail')?.value">
                                This field is required.
                            </div>
                                                        
                            <div class="error-message" *ngIf="partnerDetailsForm.get('BusinessEmail')?.touched && partnerDetailsForm.get('BusinessEmail')?.hasError('email')">
                                Please enter a valid email address.
                            </div>
                        </div>
                    </div>
                </div>
            </p-scrollPanel>
            <hr class="hr-filter" />
            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" [disabled]="partnerDetailsForm.invalid" (click)="nextTab(createPartnerTab.PersonalDetails)"></button>

            </div>
        </form>

        <form [formGroup]="personalForm" class="promo-detail-body" *ngIf="activeCreatePartnerTab === createPartnerTab.PersonalDetails">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 240px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="merchant-body-title">Complete all the information you know, otherwise leave blank</div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">Company position *</div>
                        <p-dropdown placeholder="Select" formControlName="CompanyPosition" [options]="companyPositions"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                        <div class="error-message" *ngIf="personalForm.get('CompanyPosition')?.touched && !personalForm.get('CompanyPosition')?.value">
                            This field is required.
                        </div>           
                    </div>
                </div>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-30">
                        <div class="merchant-form">
                            <div class="merchant-label">Salutation *</div>
                            <p-dropdown placeholder="Select" formControlName="Salutation" [options]="salutations"
                                        optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                            <div class="error-message" *ngIf="personalForm.get('Salutation')?.touched && !personalForm.get('Salutation')?.value">
                                This field is required.
                            </div>               
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-70">
                        <div class="merchant-form">
                            <div class="merchant-label">First Name *</div>
                            <input type="text" formControlName="FirstName" placeholder="First Name" pInputText class="italic" />
                            <div class="error-message" *ngIf="personalForm.get('FirstName')?.touched && !personalForm.get('FirstName')?.value">
                                This field is required.
                            </div>  
                        </div>
                    </div>
                </div>

               <div class="flex flex-row">
                    <div class="merchant-column merchant-column-70">
                        <div class="merchant-form">
                            <div class="merchant-label">Last Name *</div>
                            <input type="text" formControlName="LastName" placeholder="Last Name" pInputText class="italic" />
                            <div class="error-message" *ngIf="personalForm.get('LastName')?.touched && !personalForm.get('LastName')?.value">
                                This field is required.
                            </div>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-30">
                        <div class="merchant-form">
                            <div class="merchant-label">Suffix (optional)</div>
                            <p-dropdown placeholder="Select" [options]="suffixes"
                                        optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>            
                        </div>
                    </div>
                </div>
                    <div class="merchant-form">
                        <div class="merchant-label">Home Address *</div>
                        <p-autoComplete formControlName="Address"
                                        [suggestions]="addresses"
                                        (completeMethod)="search($event)"
                                        placeholder="Search Google Maps"
                                        [inputStyle]="{'width': '608px'}">
                        </p-autoComplete>
                        <div class="error-message" *ngIf="personalForm.get('Address')?.touched && !personalForm.get('Address')?.value">
                            This field is required.
                        </div>      
                    </div>
                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <input type="text" formControlName="City" placeholder="City" pInputText class="italic" />
                        </div>
                        <div class="error-message" *ngIf="personalForm.get('City')?.touched && !personalForm.get('City')?.value">
                            This field is required.
                        </div>  
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <input type="text" formControlName="PostalCode" placeholder="Zip Code" pInputText class="italic" />
                        </div>
                        <div class="error-message" *ngIf="personalForm.get('PostalCode')?.touched && !personalForm.get('PostalCode')?.value">
                            This field is required.
                        </div>  
                    </div>
                </div>

              <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Date of Birth *</div>
                            <p-calendar inputId="basic"
                                        formControlName="Birthday" 
                                        placeholder="mm/dd/yyyy" [maxDate]="currentDay"></p-calendar>
                        </div>
                        <div class="error-message" *ngIf="personalForm.get('Birthday')?.touched && !personalForm.get('Birthday')?.value">
                            This field is required.
                        </div>  
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Nationality *</div>
                            <p-dropdown placeholder="Nationality" 
                                formControlName="NationalityId" 
                                [options]="natioanlities"
                                optionLabel="Name" 
                                optionValue="Id" 
                                [showClear]="true"></p-dropdown>
                        </div>
                        <div class="error-message" *ngIf="personalForm.get('NationalityId')?.touched && !personalForm.get('NationalityId')?.value">
                            This field is required.
                        </div>  
                    </div>
                </div>

               <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Cellphone Number *</div>
                            <input type="text" formControlName="Phone" placeholder="+63" pInputText />
                        </div>
                        <div class="error-message" *ngIf="personalForm.get('Phone')?.touched && !personalForm.get('Phone')?.value">
                            This field is required.
                        </div> 
                        <div class="error-message" *ngIf="personalForm.get('Phone')?.touched && personalForm.get('Phone')?.hasError('pattern')">
                            Please enter a valid PH mobile number (e.g. +639123456789).
                          </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Work Email *</div>
                            <input type="email" formControlName="Email" placeholder="Email" pInputText class="italic"/>
                        </div>
                        <div class="error-message" *ngIf="personalForm.get('Email')?.touched && !personalForm.get('Email')?.value">
                            This field is required.
                        </div> 
                        
                        <div class="error-message" *ngIf="personalForm.get('Email')?.touched && personalForm.get('Email')?.hasError('email')">
                            Please enter a valid email address.
                        </div>
                        
                    </div>
                </div> 
            </p-scrollPanel>
            <hr class="hr-filter" />
            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" style="float: right;" [disabled]="personalForm.invalid" pButton label="Next" (click)="nextTab(createPartnerTab.Service)"></button>
            </div>
        </form>

        <form [formGroup]="serviceForm" class="promo-detail-body" *ngIf="activeCreatePartnerTab === createPartnerTab.Service">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 240px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="merchant-body-title">Select all the services that apply *</div>

                <div class="field-checkbox">
                    <p-checkbox name="group1" 
                        value="merchantServiceTypeEnum.Delivery" [value]="merchantServiceTypeEnum.Delivery" formControlName="MerchantServiceTypes"
                                inputId="merchantServiceTypeEnum.Delivery"></p-checkbox>
                    <label for="merchantServiceTypeEnum.Delivery" class="mst-label"><img src="/Content/xpress-app/images/svg/delivery.svg" /> <span class="mst-label-text">Delivery</span></label>
                </div>

                <div class="field-checkbox">
                    <p-checkbox name="group1" value="merchantServiceTypeEnum.PickUp" [value]="merchantServiceTypeEnum.PickUp"
                                formControlName="MerchantServiceTypes" inputId="merchantServiceTypeEnum.PickUp"></p-checkbox>
                    <label for="merchantServiceTypeEnum.PickUp" class="mst-label"><img src="/Content/xpress-app/images/svg/pick-up.svg" /> <span class="mst-label-text">Pick-up</span></label>
                </div>

                <div class="field-checkbox">
                    <p-checkbox name="group1" value="merchantServiceTypeEnum.Booking" [value]="merchantServiceTypeEnum.Booking"
                               formControlName="MerchantServiceTypes" inputId="merchantServiceTypeEnum.Booking"></p-checkbox>
                    <label for="merchantServiceTypeEnum.Booking" class="mst-label"><img src="/Content/xpress-app/images/svg/booking.svg" /> <span class="mst-label-text">Booking</span></label>
                </div>
                <div class="error-message" *ngIf="serviceForm.get('MerchantServiceTypes')?.touched && !serviceForm.get('MerchantServiceTypes')?.value">
                    This field is required.
                </div> 
            </p-scrollPanel>
            <hr class="hr-filter" />
            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" style="float: right;" pButton label="Next"  [disabled]="serviceForm.invalid" (click)="nextTab(createPartnerTab.Proposal)"></button>
            </div>
        </form>
        <form [formGroup]="proposalForm" class="promo-detail-body proposal" *ngIf="activeCreatePartnerTab === createPartnerTab.Proposal">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 240px)'}"
            [styleClass]="'app-scrollpanel'">

            <div class="merchant-body-title">Select the Partnership terms</div>
            <div class="merchant-column merchant-column-100">
                <div class="merchant-form">
                    <div class="merchant-label">Branch quantity*</div>
                    <input type="text" 
                           formControlName="BranchQuantity"
                           placeholder="Type here…" 
                           pInputText class="italic" 
                           (blur)="validateField('BranchQuantity')"/>
                    <div class="error-message" *ngIf="proposalForm.get('BranchQuantity')?.touched && !proposalForm.get('BranchQuantity')?.value">
                            This field is required.
                    </div>     
                </div>
            </div>
            <div class="flex flex-row">
                <div class="merchant-form delivery">
                    <div class="merchant-label">Xpress Delivery Commission *</div>
                    <p-dropdown 
                        [options]="deliveryCommissions" 
                        formControlName="DeliveryCommission"
                        optionLabel="name" 
                        placeholder="Select a commission">
                    </p-dropdown>
                    <div class="error-message" *ngIf="proposalForm.get('DeliveryCommission')?.touched && !proposalForm.get('DeliveryCommission')?.value">
                        This field is required.
                   </div>        
               </div>
                
               <div *ngIf="proposalForm.get('DeliveryCommission')?.value" class="m31">
                <div *ngIf="proposalForm.get('DeliveryCommission')?.value?.name !== 'Custom'">
                    <div><strong>MDR:</strong> {{ proposalForm.get('DeliveryCommission')?.value?.mdr }} %</div>
                    <div><strong>Commission Rate:</strong> {{ proposalForm.get('DeliveryCommission')?.value?.commissionRate }} %</div>
                </div>
             
                <div class="custom" *ngIf="proposalForm.get('DeliveryCommission')?.value?.name === 'Custom'">
                    <div>
                        <strong>MDR:</strong> 
                         <input type="number" formControlName="customDeliveryMDR" placeholder="Enter MDR" pInputText class="italic"/>
                         <div>%</div>
                    </div>
                    <div class="error-message" *ngIf="proposalForm.get('customDeliveryMDR')?.touched && !proposalForm.get('customDeliveryMDR')?.value">
                        This field is required.
                    </div>  
                    <div>
                        <strong>Commission Rate:</strong> 
                        <input type="text"  formControlName="customDeliverRate" placeholder="Enter Commission Rate" pInputText class="italic"/>
                        <div>%</div>
                    </div>
                    <div class="error-message" *ngIf="proposalForm.get('customDeliverRate')?.touched && !proposalForm.get('customDeliverRate')?.value">
                        This field is required.
                    </div>
                </div>
              </div>
            </div>  
            <div class="flex flex-row">
                <div class="merchant-form pickup">
                    <div class="merchant-label">Xpress Pickup Commission *</div>
                    <p-dropdown 
                        placeholder="Select a commission" 
                        [options]="pickupCommissions" 
                        formControlName="PickupCommission" 
                        optionLabel="name">
                    </p-dropdown>
                    <div class="error-message" *ngIf="proposalForm.get('PickupCommission')?.touched && !proposalForm.get('PickupCommission')?.value">
                        This field is required.
                    </div>
                </div>
                <div *ngIf="proposalForm.get('PickupCommission')?.value" class="m31">
                    <div *ngIf="proposalForm.get('PickupCommission')?.value?.name !== 'Custom'">
                        <div><strong>MDR:</strong> {{ proposalForm.get('PickupCommission')?.value?.mdr }} %</div>
                        <div><strong>Commission Rate:</strong> {{ proposalForm.get('PickupCommission')?.value?.commissionRate }} %</div>
                    </div>
                    <div class="custom" *ngIf="proposalForm.get('PickupCommission')?.value?.name === 'Custom'">
                        <div>
                            <strong>MDR:</strong> 
                            <input type="number"  formControlName="customPickupMDR"   placeholder="Enter MDR"  pInputText class="italic"/>
                            <div>%</div>
                        </div>
                        <div class="error-message" *ngIf="proposalForm.get('customPickupMDR')?.touched && !proposalForm.get('customPickupMDR')?.value">
                            This field is required.
                        </div>
                        <div>
                            <strong>Commission Rate:</strong> 
                            <input type="text" formControlName="customPickupRate" placeholder="Enter Commission Rate"  pInputText class="italic"/>
                            <div>%</div>
                        </div>
                        <div class="error-message" *ngIf="proposalForm.get('customPickupRate')?.touched && !proposalForm.get('customPickupRate')?.value">
                            This field is required.
                        </div>
                    </div>
                </div>
            </div>
            <hr class="hr-filter" />
            <div>
                <div class="merchant-form promooffer" >
                   <div>
                       <div class="merchant-label">Promo offer *</div>
                       <p-dropdown placeholder="Select Promo offer" 
                           formControlName="PromoOffer"
                           optionLabel="name"
                           [showClear]="true" 
                           [options]="promoOffer"
                           [appendTo]="'body'"
                           (blur)="validateField('PromoOffer')">
                       </p-dropdown>
                       <div class="error-message" *ngIf="proposalForm.get('PromoOffer')?.touched && !proposalForm.get('PromoOffer')?.value">
                          This field is required.
                       </div>
                   </div>
                   <div class="marT20">
                       <div *ngIf="proposalForm.get('PromoOffer')?.value">
                           <div *ngIf="proposalForm.get('PromoOffer')?.value?.name !== 'Custom'">
                               <div><strong>Percentage: </strong>{{ proposalForm.get('PromoOffer')?.value?.commissionOffer}} %</div><div><strong>Duration: </strong>{{proposalForm.get('PromoOffer')?.value?.duration }}</div>
                               <div class="merchant-label">Advertising offer: {{proposalForm.get('PromoOffer')?.value?.advertising }}</div>
                           </div>
                           
                           <div *ngIf="proposalForm.get('PromoOffer')?.value?.name === 'Custom'">
                               <div><strong>Percentage: * </strong> 
                                <input type="text" formControlName="customPromo" (blur)="validateField('customPromo')" placeholder="Enter Percentage" pInputText class="italic" />
                                <div class="error-message" *ngIf="proposalForm.get('customPromo')?.touched && !proposalForm.get('customPromo')?.value">
                                    This field is required.
                                 </div>
                            </div>
                               <div><strong>Duration: *</strong> 
                                <input type="text" formControlName="customDuration" (blur)="validateField('customDuration')" placeholder="Enter Duration" pInputText class="italic"/>
                                <div class="error-message" *ngIf="proposalForm.get('customDuration')?.touched && !proposalForm.get('customDuration')?.value">
                                    This field is required.
                                 </div>
                                </div>
                               <div><strong>Advertising offer: *</strong>
                                <input type="text" formControlName="customPromoAdd" (blur)="validateField('customPromoAdd')" placeholder="Enter Advertising Offer" pInputText class="italic" /></div>
                                <div class="error-message" *ngIf="proposalForm.get('customPromoAdd')?.touched && !proposalForm.get('customPromoAdd')?.value">
                                    This field is required.
                                 </div>
                            </div>
                       </div>
                   </div>
                </div>
                <hr class="hr-filter" />
                <div  *ngIf="proposalForm.get('PromoOffer')?.value">
                   <p *ngIf="proposalForm.get('PromoOffer')?.value?.name === 'Starter'">
                       <strong>Starter Plan (16% Commission) – “Effortless Online Presence”</strong><br>
                         "Start selling online with 0% commission for your first 30 days!" 
                       The Starter Plan is for small restaurants that want to increase orders without extra costs. 
                       Enjoy zero commission for your first month, then just 16% per order with full Xpress delivery.<br><br>
                         1. 0% commission for the first 30 days – More profits upfront <br>
                         2. Lowest commission (16%) after trial – Keep more earnings <br>
                         3. No extra marketing costs – List your restaurant for free <br>
                         4. Seamless Xpress Eats integration – Get orders instantly <br><br>
                        <strong>Who is this for?</strong> Small/local restaurants that want simple online ordering and delivery without extra marketing costs.<br>
                        <strong>Sign up today and start accepting orders with 0% commission!</strong>
                   </p>
                   <p *ngIf="proposalForm.get('PromoOffer')?.value?.name === 'Growth'">
                        <strong>Growth Plan (20% Commission) - “Expand & Increase Your Reach”</strong><br>
                        "0% commission for 60 days + ₱20,000/month in ad credits for a year!" 
                       The Growth Plan is designed for restaurants looking to scale fast with increased visibility, 
                       full delivery, and marketing support. Plus, sign up before June 30 and get ₱20K per month in free ad credits for 12 months!<br><br>
                        1. 0% commission for 60 days - More profits upfront <br>
                        2. ₱20K/month in ad credits (₱240K total) - More customers, more orders <br>
                        3. Xpress Eats marketing support - Appear in featured searches <br>
                        4. Professional delivery management - No need for your own riders <br><br>
                        <strong>Who is this for?</strong> Restaurants looking to increase delivery volume and visibility without upfront costs.<br>
                        <strong>Sign up before June 30 to lock in your free ₱240K in ad credits!</strong>
                   </p>
                   <p *ngIf="proposalForm.get('PromoOffer')?.value?.name === 'Elite'">
                       <strong>Elite Plan (24% Commission) - “Maximize Sales & Dominate the Market”</strong><br>
                        "0% commission for 90 days + ₱40,000/month in ad credits for a year!" The Elite Plan is the fastest way to 
                        scale your restaurant with top-tier search placement, premium promotions, and priority delivery. Plus, sign up before June 30 
                        and get ₱40K per month in ad credits for 12 months!
                       1. 0% commission for 90 days - Maximize earnings before fees start <br>
                       2. ₱40K/month in ad credits (₱480K total) - Premium visibility, higher sales <br>
                       3. Top search placement - Appear first in customer searches <br>
                       4. High-impact marketing campaigns – Paid promotions, in-app banners & ads <br>
                       5. Full-service delivery & growth strategy – We handle everything<br><br>
                       <strong>Who is this for?</strong> High-volume restaurants that want to dominate search rankings, run marketing campaigns, and drive massive sales.
                       <strong> Sign up before June 30 and claim your ₱480K in free ad credits!</strong>
                  </p>
               </div>
            </div>
            </p-scrollPanel>
            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" style="float: right;"  
                [disabled]="proposalForm.invalid || (proposalForm.get('DeliveryCommission')?.value?.name === 'Custom' &&(!proposalForm.get('customDeliveryMDR')?.value || !proposalForm.get('customDeliverRate')?.value)) || (proposalForm.get('PickupCommission')?.value?.name === 'Custom' &&
                  (!proposalForm.get('customPickupMDR')?.value || !proposalForm.get('customPickupRate')?.value)) || (proposalForm.get('PromoOffer')?.value?.name === 'Custom' &&
                  (!proposalForm.get('customPromo')?.value || !proposalForm.get('customDuration')?.value || !proposalForm.get('customPromoAdd')?.value))"                                                                             
               pButton label="Preview Proposal" (click)="nextTab(createPartnerTab.Preview)"></button>            
            </div>
          
        </form>
        <div class="promo-detail-body" *ngIf="activeCreatePartnerTab === createPartnerTab.Preview">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 240px)'}"
               [styleClass]="'app-scrollpanel'">
               
               <div class="merchantTitle">Company Details</div>

               <div *ngIf="partnerDetailsForm.get('BusinessName')?.value">
                 <strong>Registered Company Name (same as SEC document) *</strong>
                 {{ partnerDetailsForm.get('BusinessName')?.value }}
               </div>
               
               <div *ngIf="partnerDetailsForm.get('BusinessAddress')?.value">
                 <strong>Company Address:</strong> {{ partnerDetailsForm.get('BusinessAddress')?.value }}
               </div>
               
               <div *ngIf="partnerDetailsForm.get('BusinessCity')?.value">
                 <strong>City:</strong> {{ partnerDetailsForm.get('BusinessCity')?.value }}
               </div>
               
               <div *ngIf="partnerDetailsForm.get('BusinessPostalCode')?.value">
                 <strong>Postal Code:</strong> {{ partnerDetailsForm.get('BusinessPostalCode')?.value }}
               </div>
               
               <div *ngIf="partnerDetailsForm.get('TradingName')?.value">
                 <strong>Trading Name:</strong> {{ partnerDetailsForm.get('TradingName')?.value }}
               </div>
               
               <div *ngIf="partnerDetailsForm.get('BusinessPhone')?.value">
                 <strong>Company Phone:</strong> {{ partnerDetailsForm.get('BusinessPhone')?.value }}
               </div>
               
               <div *ngIf="partnerDetailsForm.get('BusinessEmail')?.value">
                 <strong>Company Email *:</strong> {{ partnerDetailsForm.get('BusinessEmail')?.value }}
               </div>
               
               <hr class="hr-filter" />
               
               <!-- Personal Details Section -->
               <div class="merchantTitle">Personal Details</div>
               
               <div *ngIf="personalForm.get('CompanyPosition')?.value">
                 <strong>Company Position:</strong> {{ personalForm.get('CompanyPosition')?.value }}
               </div>
               
               <div *ngIf="personalForm.get('Salutation')?.value">
                 <strong>Salutation:</strong> {{ personalForm.get('Salutation')?.value }}
               </div>
               
               <div *ngIf="personalForm.get('FirstName')?.value">
                 <strong>First Name:</strong> {{ personalForm.get('FirstName')?.value }}
               </div>
               
               <div *ngIf="personalForm.get('LastName')?.value">
                 <strong>Last Name:</strong> {{ personalForm.get('LastName')?.value }}
               </div>
               
               <div *ngIf="personalForm.get('Birthday')?.value">
                 <strong>Birthday:</strong> {{ personalForm.get('Birthday')?.value }}
               </div>
               
               <div *ngIf="personalForm.get('Phone')?.value">
                 <strong>Phone:</strong> {{ personalForm.get('Phone')?.value }}
               </div>
               
               <div *ngIf="personalForm.get('Email')?.value">
                 <strong>Email:</strong> {{ personalForm.get('Email')?.value }}
               </div>
               
               <hr class="hr-filter" />
               
               <!-- Services Section -->
               <div class="merchantTitle">Services</div>
               
               <div *ngIf="serviceForm.get('MerchantServiceTypes')?.value?.length > 0">
                 <strong>Service Types:</strong>
                 <ul>
                   <li *ngFor="let serviceType of serviceForm.get('MerchantServiceTypes')?.value">
                     {{ getServiceTypeLabel(serviceType) }}
                   </li>
                 </ul>
               </div>
               
               <hr class="hr-filter" />
               
               <!-- Proposal Section -->
               <div class="merchantTitle">Proposal</div>
               
               <div *ngIf="proposalForm.get('BranchQuantity')?.value">
                 <strong>Branch Quantity:</strong> {{ proposalForm.get('BranchQuantity')?.value }}
               </div>
               
               <div *ngIf="proposalForm.get('DeliveryCommission')?.value?.name !== 'Custom'">
                <div><strong>Delivery MDR:</strong> {{ proposalForm.get('DeliveryCommission')?.value?.mdr }} %</div>
                <div><strong>Commission Rate:</strong> {{ proposalForm.get('DeliveryCommission')?.value?.commissionRate }} %</div>
              </div>

              <div *ngIf="proposalForm.get('DeliveryCommission')?.value?.name === 'Custom'">
                <div>
                    <div><strong>Custom Delivery MDR:</strong> {{ proposalForm.get('customDeliveryMDR')?.value }} %</div>
                    <div><strong>Custom Commission Rate:</strong> {{ proposalForm.get('customDeliverRate')?.value }} %</div>
                </div>  
              </div>
               
    
               <div *ngIf="proposalForm.get('PickupCommission')?.value?.name !== 'Custom'">
                <div><strong>Pickup MDR:</strong> {{ proposalForm.get('PickupCommission')?.value?.mdr }} %</div>
                <div><strong>Pickup Commission Rate:</strong> {{ proposalForm.get('PickupCommission')?.value?.commissionRate }} %</div>
               </div>

               <div *ngIf="proposalForm.get('PickupCommission')?.value?.name === 'Custom'">
                    <div><strong>Custom Pickup MDR:</strong> {{ proposalForm.get('customPickupMDR')?.value }} %</div>
                    <div><strong>Custom Pickup Commission Rate:</strong> {{ proposalForm.get('customPickupRate')?.value }} %</div>
                </div>
               
               <div *ngIf="proposalForm.get('PromoOffer')?.value?.name !== 'Custom'">
                <div>
                    <strong>Percentage: </strong>{{ proposalForm.get('PromoOffer')?.value?.commissionOffer}} %</div>
                <div>
                    <strong>Duration: </strong>{{proposalForm.get('PromoOffer')?.value?.duration }}</div>
                <div><strong>Advertising offer: </strong> {{proposalForm.get('PromoOffer')?.value?.advertising }}</div>
              </div>
              <div *ngIf="proposalForm.get('PromoOffer')?.value?.name === 'Custom'">
                <div><strong>Percentage: </strong>{{ proposalForm.get('customPromo')?.value}} %</div>
                <div>
                     <strong>Duration: </strong>{{proposalForm.get('customDuration')?.value.duration }}</div>
                <div>
                     <strong>Advertising offer: </strong> {{proposalForm.get('customPromoAdd')?.value }}</div>
              </div>
              <div *ngIf="proposalForm.get('PromoOffer')?.value?.name === 'None'"></div>
                 
            </p-scrollPanel>
            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" style="float: right;"  pButton label="Send invite" (click)="createMerchant()"></button>
            </div>
      </div>
    </div>

</p-sidebar>